import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingOverlay from "../../../utilities/LoadingOverlay";
import { ClipLoader } from "react-spinners";
import { defaultLoadingOverlayStyles } from "../../../utilities/loadingOverlay.styles";
import Menu from "../shared/Menu";
import Footer from "../shared/Footer";
import Modal from "../Modal/index";
import Dashboard from "./Dashboard";
import MemberInfo from "./MemberInfo";
import AccountInfo from "../MyProfile/AccountInfo";
import UpdateContact from "../MyProfile/UpdateContactInfo";
import ControlContact from "../MyProfile/ControlContactInfo";
import MemberDetail from "./MemberDetail";
import CreatePaymentOrder from "../PaymentOrder/CreatePaymentOrder";
import ListPayments from "../PaymentOrder/ListPayments";
import $ from 'jquery';


import CreatePaymentOrderPayFor from "../PaymentOrderPayFor/CreatePaymentOrderPayFor";
import CreatePayment from "../Payment/CreatePayment";
// import ListPaymentsPayFor from "../PaymentOrderPayFor/ListPaymentsPayFor";


import MyReferences from "../References/MyReferences";
import SubmitReference from "../References/SubmitReference";
import ReferenceRules from "../References/ReferenceRules";
import SubmitDemand from "../Demands/SubmitDemand";
import MyDemands from "../Demands/MyDemands";
import Questions from "./Questions";
import AskToAgent from "../Agent/AskToAgent";
import ResetPassword from "./ResetPassword";
import AnnouncementDetail from "./AnnouncementDetail";
import SmartCalculation from "../Calculation/SmartCalculation";
import { history } from "../../../utilities/history";
import { Route, Switch, Router } from "react-router-dom";
import {
  beginLogout,
  selectAuthenticate,
  refreshToken
} from "../../../state/ducks/login/index";
import { selectAlertMessage } from "../../../state/ducks/alert/index";
import AgentInfo from "./AgentInfo";
import { selectDashboardInfo } from "../../../state/ducks/dashboard";
import AydinlatmaMetni from "../Modal/AydinlatmaMetni";
import SmsVerification from "../Calculation/SmsVerification";
import Result from "../Calculation/Result";
import PersonalInfo from "../Calculation/PersonalInfo";
import NewAddress from "../Calculation/NewAddress";
import CreditCardPayTR from "../PaymentOrderPayTR/CreditCardPayTR";
import CreatePaymentOrderPayTr from "../PaymentOrderPayTR/CreatePaymentOrderPayTr";
import CreatePaymentOrderEminPay from "../PaymentOrderEminPay/CreatePaymentOrderEminPay";

function changebg() {
  document.body.background = "";
  document.body.className = "t-dashboardBack";
  document.body.id = "";
  document.body.style.backgroundImage = "";
  document.body.style.backgroundSize = "";
  document.body.style.backgroundRepeat = "";
  document.body.style.backgroundPosition = "";
}
function modalWithControl(Width) {

  var modalGenel = document.getElementById("id-modalTipi");
  var modalIptal = document.getElementById("id-modalIptal");
  if (modalGenel != null) {
    // ekranı sürekli dinle
    window.addEventListener("resize", function () {
      if (window.innerWidth < 900) {
        modalGenel.style.width = "90%"; // Modal Genişlipği
        if (modalIptal != null) {

          modalIptal.style.width = "90%"
        }
      } else {
        modalGenel.style.width = "55%"; // Modal Genişlipği
        if (modalIptal != null) {

          modalIptal.style.width = "30%";
        }
      }
    });

  }

}

class Home extends Component {
  state = {
    windowWidth: "0",
    intervalId: null,
    timerCount: 0,
    timerDuration: 30
  }
  beginLogout = () => {
    this.props.beginLogout();
  };

  componentDidMount() {
    changebg();
    window.addEventListener('resize', this.handleWindowSizeChange);
    $("#expireTokenModal").modal({
      backdrop: "static",
      keyboard: false,
      show: false,
    });
    this.startTimer();
    const count = parseInt(sessionStorage.getItem("tokenExpireTime"), 10);

    if (!Number.isNaN(count) && count <= 30) {
      this.setState({ timerDuration: count, timerCount: count });
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    clearInterval(this.state.intervalId);
  }

  handleWindowSizeChange = () => {
    this.setState({ windowWidth: window.innerWidth });

    //  modalWithControl(this.state.windowWidth)
  };

  expireTokenYes = () => {

    sessionStorage.setItem("tokenExpireTime", (35).toString())
    $("#expireTokenModal").modal('hide');
    refreshToken().then((login) => {
      sessionStorage.setItem("token", login.token);
      sessionStorage.setItem("refreshToken", login.refreshToken);
      sessionStorage.setItem("tokenExpireTime", (login.tokenExpireTime * 60).toString())
      // sessionStorage.setItem("tokenExpireTime", (60).toString())

    });
  }

  uniqId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  };

  expireTokenNo = () => {
    this.props.beginLogout();
  }

  startTimer = () => {
    const intervalId = setInterval(() => {


      var count = parseInt(sessionStorage.getItem("tokenExpireTime")) - 1;
      this.setState({ timerCount: count });
      sessionStorage.setItem("tokenExpireTime", count.toString());
      if (count <= 0) {
        clearInterval(this.state.intervalId);
        this.props.beginLogout();
      }
      else if (count <= 30) {
        if (count === 30) {
          this.setState({ timerDuration: count, timerCount: count });
        }
        $("#expireTokenModal").modal('show');
      }

    }, 1000);

    this.setState({ intervalId });
  };

  getSessionTimerTone = () => {
    const count = Math.max(this.state.timerCount, 0);

    if (count <= 10) return "danger";
    if (count <= 20) return "warn";
    return "safe";
  };

  getSessionTimerProgress = () => {
    const { timerCount, timerDuration } = this.state;
    const total = Math.max(timerDuration, 1);
    const remaining = Math.max(Math.min(timerCount, total), 0);

    return remaining / total;
  };

  renderSessionExpireTimer = () => {
    const { timerCount, timerDuration } = this.state;
    const tone = this.getSessionTimerTone();
    const radius = 54;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference * (1 - this.getSessionTimerProgress());
    const displayTime = Math.max(timerCount, 0);

    return (
      <div
        className={`t-sessionExpire-timer t-sessionExpire-timer--${tone}`}
        role="timer"
        aria-live="polite"
        aria-label={`Kalan süre ${displayTime} saniye`}
      >
        <svg className="t-sessionExpire-ring" viewBox="0 0 120 120" aria-hidden="true">
          <circle className="t-sessionExpire-ringGlow" cx="60" cy="60" r="54" />
          <circle className="t-sessionExpire-ringTrack" cx="60" cy="60" r={radius} />
          <circle
            className={`t-sessionExpire-ringProgress t-sessionExpire-ringProgress--${tone}`}
            cx="60"
            cy="60"
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
        <div className="t-sessionExpire-timerCenter">
          <span className="t-sessionExpire-timerValue">{displayTime}</span>
          <span className="t-sessionExpire-timerUnit">saniye</span>
          <span className="t-sessionExpire-timerTotal">/ {timerDuration}</span>
        </div>
      </div>
    );
  };

  renderSessionExpireModal = () => (
    <div
      className="modal fade t-sessionExpire-modal"
      id="expireTokenModal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sessionExpireTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered t-sessionExpire-dialog">
        <div className="modal-content t-sessionExpire-content">
          <div className="t-sessionExpire-accent" aria-hidden="true" />

          <div className="t-sessionExpire-icon" aria-hidden="true">
            <i className="t-icon-clock" />
          </div>

          <span className="t-sessionExpire-badge">Oturum Uyarısı</span>

          <h2 className="t-sessionExpire-title" id="sessionExpireTitle">
            Devam etmek istiyor musunuz?
          </h2>

          <p className="t-sessionExpire-text">
            Güvenliğiniz için kısa süre içinde oturumunuz sonlandırılacaktır.
            İşleminize devam etmek istiyorsanız lütfen onaylayın.
          </p>

          {this.renderSessionExpireTimer()}

          <div className="t-sessionExpire-actions">
            <button
              type="button"
              className="t-sessionExpire-btn t-sessionExpire-btn--ghost"
              onClick={this.expireTokenNo}
            >
              Hayır, çıkış yap
            </button>
            <button
              type="button"
              className="t-sessionExpire-btn t-sessionExpire-btn--primary"
              onClick={this.expireTokenYes}
            >
              Evet, devam et
            </button>
          </div>
        </div>
      </div>
    </div>
  );


  render() {
    const { login, alert, dashboard } = this.props;


    return (

      <LoadingOverlay active={alert?.loading} spinner={<ClipLoader />} styles={defaultLoadingOverlayStyles}>

        <Router history={history}>
          <Modal message={alert?.message} type={alert?.type} />
          <AydinlatmaMetni></AydinlatmaMetni>

          <div className="t-container ml-auto mr-auto">
            <aside className="t-solMenuArea t-appSidebar" aria-label="Ana menü">
              <div className="t-solmenuicerik t-appSidebar-inner t-appNav-scope">
                <div className="t-appSidebar-glow t-appSidebar-glow--top" aria-hidden="true" />
                <div className="t-appSidebar-glow t-appSidebar-glow--bottom" aria-hidden="true" />

                <div className="t-appSidebar-brand">
                  <img src="/assets/img/svg/logo_internetSube.svg" alt="Eminevim İnternet Şube" />
                </div>

                <div className="t-appSidebar-user">
                  <div className="t-appSidebar-avatarRing">
                    <img src="/assets/img/svg/icon_avatar.svg" alt="" aria-hidden="true" />
                  </div>
                  <div className="t-appSidebar-userMeta">
                    <span className="t-appSidebar-welcome">Hoş geldiniz</span>
                    <span className="t-appSidebar-username">{login.info.username}</span>
                  </div>
                </div>

                <nav className="t-solmenu t-appSidebar-nav">
                  <ul className="t-appNav-list accordion" id="sol_menu">
                    <Menu count={dashboard.menuCount} accordionId="sol_menu" />
                  </ul>
                </nav>
              </div>

              <div className="t-solMenuGuvenliCikis t-appSidebar-logout">
                <button type="button" className="t-appSidebar-logoutBtn" onClick={this.beginLogout}>
                  <i className="t-icon-switch" aria-hidden="true" />
                  <span>Güvenli Çıkış</span>
                </button>
              </div>
            </aside>

            <div className="t-sagicerik">
              <div className="t-appPageBody">
              <div className="t-mobilMenuArea t-appMobileBar">
                <div className="t-mobilMenu t-appMobileBar-inner">
                  <img
                    src="/assets/img/svg/logo_internetSube.svg"
                    alt="Eminevim İnternet Şube"
                    className="t-appMobileBar-logo"
                  />
                  <button
                    type="button"
                    className="t-appMobileBar-toggle"
                    data-toggle="collapse"
                    data-target="#mobilmenu"
                    aria-expanded="false"
                    aria-controls="mobilmenu"
                    aria-label="Menüyü aç"
                  >
                    <span className="t-appMobileBar-toggleLines" aria-hidden="true">
                      <span />
                      <span />
                      <span />
                    </span>
                  </button>
                </div>
              </div>

              <div className="t-MobilMenuAltArea t-appMobileDrawer">
                <div className="collapse t-appMobileDrawer-panel" id="mobilmenu">
                  <div className="t-appMobileDrawer-shell t-appNav-scope">
                    <div className="t-appSidebar-glow t-appSidebar-glow--top" aria-hidden="true" />

                    <div className="t-appMobileDrawer-header">
                      <div className="t-appSidebar-user t-appSidebar-user--compact">
                        <div className="t-appSidebar-avatarRing">
                          <img src="/assets/img/svg/icon_avatar.svg" alt="" aria-hidden="true" />
                        </div>
                        <div className="t-appSidebar-userMeta">
                          <span className="t-appSidebar-welcome">Hoş geldiniz</span>
                          <span className="t-appSidebar-username">{login.info.username}</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="t-appMobileDrawer-logout"
                        onClick={this.beginLogout}
                        aria-label="Güvenli çıkış"
                      >
                        <i className="t-icon-switch" aria-hidden="true" />
                      </button>
                    </div>

                    <nav className="t-solmenu t-appSidebar-nav t-appSidebar-nav--mobile">
                      <ul className="t-appNav-list accordion" id="ust_menu">
                        <Menu count={dashboard.menuCount} accordionId="ust_menu" />
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <Switch>
                <Route
                  exact
                  path="/Home/DashBoard"
                  render={props => <Dashboard login={login} {...props} />}
                />
                <Route
                  exact
                  path="/Home/MemberInfo"
                  component={MemberInfo}
                />
                <Route
                  exact
                  path="/Home/AccountInfo"
                  component={AccountInfo}
                />
                <Route exact path="/Home/AgentInfo" component={AgentInfo} />
                <Route
                  exact
                  path="/Home/MemberDetail/:id"
                  component={MemberDetail}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrder"
                  component={CreatePaymentOrder}
                />
                <Route
                  exact
                  path="/Home/ListPayments"
                  component={ListPayments}
                />

                <Route
                  exact
                  path="/Home/CreatePaymentOrderPayFor"
                  component={CreatePaymentOrderPayFor}
                />



                <Route
                  exact
                  path="/Home/CreatePayment"
                  render={props => <CreatePayment dashboard={dashboard} {...props} />}
                />

                {/* <Route
                  exact
                  path="/Home/ListPaymentsPayFor"
                  component={ListPaymentsPayFor}
                /> */}


                <Route
                  exact
                  path="/Home/SubmitReference"
                  component={SubmitReference}
                />
                <Route
                  exact
                  path="/Home/MyReferences"
                  component={MyReferences}
                />
                <Route
                  exact
                  path="/Home/ReferenceRules"
                  component={ReferenceRules}
                />
                <Route
                  exact
                  path="/Home/SubmitDemand"
                  component={SubmitDemand}
                />
                <Route exact path="/Home/MyDemands" component={MyDemands} />
                <Route exact path="/Home/Questions" component={Questions} />
                <Route
                  exact
                  path="/Home/AskToAgent"
                  component={AskToAgent}
                />
                <Route
                  exact
                  path="/Home/ResetPassword"
                  component={ResetPassword}
                />
                <Route
                  exact
                  path="/Home/AnnouncementDetail/:id"
                  component={AnnouncementDetail}
                />
                <Route
                  exact
                  path="/Home/SmartCalculation"
                  component={SmartCalculation}
                />
                <Route
                  exact
                  path="/Home/SmsVerification"
                  component={SmsVerification}
                />
                <Route
                  exact
                  path="/Home/PersonalInfo"
                  component={PersonalInfo}
                />
                <Route
                  exact
                  path="/Home/NewAddress"
                  component={NewAddress}
                />
                <Route
                  exact
                  path="/Home/Result"
                  component={Result}
                />
                <Route
                  exact
                  path="/Home/ControlContactInfo/:id"
                  component={ControlContact}
                />
                <Route
                  exact
                  path="/Home/UpdateContactInfo/:id"
                  component={UpdateContact}
                />
                <Route
                  exact
                  path="/Home/CreditCardPayTR"
                  component={CreditCardPayTR}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrderPayTr"
                  component={CreatePaymentOrderPayTr}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrderEminPay"
                  component={CreatePaymentOrderEminPay}
                />
              </Switch>
              </div>
              <Footer></Footer>
            </div>

          </div>
        </Router>

        {this.renderSessionExpireModal()}

      </LoadingOverlay >
    );
  }
}

const mapStateToProps = state => {
  return {
    login: selectAuthenticate(state),
    alert: selectAlertMessage(state),
    dashboard: selectDashboardInfo(state)
  };
};

const mapDispatchToProps = dispatch => ({
  beginLogout: () => dispatch(beginLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
export {
  history
};
